import { render, staticRenderFns } from "./PointFilterDefaultLayout.vue?vue&type=template&id=b852a10a&"
import script from "./PointFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PointFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports